export const QA_NAME_APPOINTMENT_FOLLOW_UP_MODAL = 'appointmentFollowUpModal'
